import React from 'react';
import { teamMembers } from '../data/mock';
import { Users, Target, Award } from 'lucide-react';

export const About = () => {
  const features = [
    {
      icon: Users,
      title: 'Production Team',
      description: 'Professional content creators and editors'
    },
    {
      icon: Target,
      title: 'Data-Driven',
      description: 'Analytics and performance optimization'
    },
    {
      icon: Award,
      title: 'Scale Operations',
      description: 'Managing 300+ digital properties'
    }
  ];

  return (
    <section id="about" className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-[#0f172a] to-[#0a0a0a]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(6,182,212,0.05),transparent_50%)]"></div>
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4">
            About Monatiz Digital
          </h2>
          <p className="text-lg text-slate-400 max-w-3xl mx-auto">
            We are a digital content production and distribution company, operating large-scale content networks across Facebook and YouTube platforms. Our business model focuses on producing high-quality content and maximizing ad revenue through platform expertise and data-driven strategies.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden border border-slate-700/50 shadow-2xl shadow-cyan-500/5">
              <img
                src="https://images.unsplash.com/photo-1758691737543-09a1b2b715fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjB0ZWFtJTIwY29sbGFib3JhdGlvbnxlbnwwfHx8fDE3NjMxOTc5MjJ8MA&ixlib=rb-4.1.0&q=85"
                alt="Monatiz Digital Team"
                className="w-full h-full object-cover opacity-90"
              />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-gradient-to-br from-cyan-500/10 to-blue-500/10 rounded-2xl -z-10 blur-xl"></div>
          </div>

          {/* Content */}
          <div>
            <h3 className="text-3xl sm:text-4xl font-bold text-white mb-6">
              Our Mission
            </h3>
            <p className="text-slate-300 mb-6 leading-relaxed">
              At Monatiz Digital, we operate as a content production powerhouse, managing 200+ Facebook Fanpages and 100+ YouTube Channels. Our mission is to build sustainable revenue streams through strategic content creation and platform optimization.
            </p>
            <p className="text-slate-300 mb-8 leading-relaxed">
              We leverage deep platform knowledge, advanced analytics, and professional production capabilities to maximize content performance and ad revenue across our digital properties.
            </p>

            {/* Features Grid */}
            <div className="grid sm:grid-cols-3 gap-6">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div key={index} className="text-center p-6 rounded-xl bg-gradient-to-br from-slate-800/40 to-slate-900/40 backdrop-blur-sm border border-slate-700/50 hover:border-cyan-500/30 transition-all duration-300">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 rounded-xl mb-4">
                      <Icon className="w-8 h-8 text-cyan-400" />
                    </div>
                    <h4 className="font-semibold text-white mb-2">{feature.title}</h4>
                    <p className="text-sm text-slate-400">{feature.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
